var RS_FILES = window.RS_FILES || 'assets/';
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches)
    return;
  document.querySelectorAll('.qa').forEach(function (qa) {
    var sum = qa.querySelector('summary'), anim = null;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      var start = qa.offsetHeight, opening = !qa.open || qa.classList.contains('is-closing');
      if (anim)
        anim.cancel();
      qa.classList.remove('is-closing');
      if (opening)
        qa.open = true;
      else
        qa.classList.add('is-closing');
      var end = opening ? qa.scrollHeight : sum.offsetHeight + 1;
      if (opening) {
        qa.style.height = 'auto';
        end = qa.offsetHeight;
      }
      anim = qa.animate({ height: [start + 'px', end + 'px'] }, { duration: 380, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
      anim.onfinish = function () {
        anim = null;
        qa.style.height = '';
        if (!opening) {
          qa.open = false;
          qa.classList.remove('is-closing');
        }
      };
    });
  });
})();
(function () {
  var proof = document.querySelector('.proof');
  var proofStage = proof.querySelector('.proof__stage');
  var proofPhoto = proof.querySelector('.proof__photo');
  var phone = innerWidth <= 860;
  var phonePin = phone && !matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (phone) {
    var intro = proof.querySelector('.proof__intro');
    var award = intro.querySelector('.award');
    var lede = intro.querySelector('.sc-lede');
    var stats = intro.querySelector('.stats');
    intro.insertBefore(proofPhoto, intro.querySelector('h2').nextSibling);
    intro.insertBefore(award, proofPhoto.nextSibling);
    intro.appendChild(lede);
    intro.appendChild(stats);
    if (phonePin) {
      var more = document.createElement('section');
      more.className = 'proof-more';
      more.setAttribute('data-sc-act', 'flow');
      more.innerHTML = '<div class="sc-wrap"><div data-sc-in data-sc-stagger="80"></div></div>';
      more.querySelector('[data-sc-in]').appendChild(lede);
      more.querySelector('[data-sc-in]').appendChild(stats);
      proof.parentNode.insertBefore(more, proof.nextSibling);
      if (proofStage.offsetHeight + 40 > innerHeight) {
        intro.appendChild(lede);
        intro.appendChild(stats);
        more.remove();
        phonePin = false;
      }
    }
  }
  var pinProof = !matchMedia('(prefers-reduced-motion: reduce)').matches &&
    (phonePin || (innerWidth > 860 && proofStage.offsetHeight + 120 <= innerHeight));
  if (pinProof) {
    proof.setAttribute('data-sc-act', 'pin');
    proof.setAttribute('data-sc-span', '1.8');
    proofStage.setAttribute('data-sc-stage', '');
    proof.classList.add('proof--pinned');
  }
  ScrollCraft.mount(document.body);
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var small = matchMedia('(max-width: 860px)');
  var clamp01 = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };
  var ease = function (x) { x = clamp01(x); return x * x * (3 - 2 * x); };
  var range = function (p, a, b) { return clamp01((p - a) / (b - a)); };
  var mix = function (a, b, t) { return a + (b - a) * t; };
  function actP(el) {
    var r = el.getBoundingClientRect();
    var travel = Math.max(r.height - innerHeight, 1);
    return clamp01(-r.top / travel);
  }
  function near(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > -innerHeight && r.top < innerHeight * 2;
  }
  var walk = document.querySelector('.walk');
  var stage = walk.querySelector('[data-sc-stage]');
  var sky = walk.querySelector('.sky');
  var mirage = walk.querySelector('.mirage');
  var NEXT = [12, 4, 52];
  var canvas = walk.querySelector('.burn');
  var title = walk.querySelector('.hero-title');
  var cta = walk.querySelector('.hero-cta');
  var hint = walk.querySelector('.hero-hint');
  var lastY = scrollY, vel = 0;
  var DR = { x: 0, y: 0, vx: 0, vy: 0, tx: 0, ty: 0, held: false, heat: 0, t: 0, free: null };
  function geo(p) {
    var W = stage.clientWidth, H = stage.clientHeight;
    var tb = title.offsetTop + title.offsetHeight;
    var room = Math.max(cta.offsetTop - tb, H * 0.28);
    var hintTop = tb + room - Math.max(room * 0.1, 24) - hint.offsetHeight;
    var gap = hintTop - tb;
    var cy0 = tb + gap / 2, h0 = gap * 0.84, w0 = h0 * 0.58;
    var g = ease(range(p, 0.04, 0.95));
    var swell = Math.pow(g, 1.7);
    var R = Math.max(W, H) * 1.2;
    var s = { W: W, H: H, g: g, cy0: cy0, h0: h0, fill: ease(range(p, 0.1, 0.65)) };
    hint.style.top = hintTop.toFixed(1) + 'px';
    s.fx = W / 2;
    s.fy = mix(cy0, H / 2, g);
    s.hx = mix(w0 / 2, R, swell);
    s.hy = mix(h0 / 2, R, swell);
    s.fx += DR.x * (1 - g);
    s.fy += DR.y * (1 - g);
    return s;
  }
  var VS = 'attribute vec2 a;varying vec2 v;void main(){v=a*.5+.5;gl_Position=vec4(a,0.,1.);}';
  var FS = [
    'precision highp float;',
    'uniform sampler2D uBg,uVid,uWall;',
    'uniform vec2 uRes;uniform float uWob,uDpr,uTime,uVel,uRise,uHaze,uOpen,uWallOn,uSpark,uBgA,uVidA,uWallA;',
    'uniform vec4 uFlame,uVBox;uniform vec3 uNext;uniform float uFill;',
    'float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float noise(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);',
    ' return mix(mix(hash(i),hash(i+vec2(1,0)),u.x),mix(hash(i+vec2(0,1)),hash(i+vec2(1,1)),u.x),u.y);}',
    'float fbm(vec2 p){float s=0.,a=.5;for(int i=0;i<4;i++){s+=a*noise(p);p=p*2.03+7.1;a*=.5;}return s;}',
    'vec2 cover(vec2 uv,float tA,float bA){vec2 s=bA>tA?vec2(1.,tA/bA):vec2(bA/tA,1.);return (uv-.5)*s+.5;}',
    'float sparks(vec2 f,float t){float s=0.;',
    ' for(int i=0;i<3;i++){float fi=float(i);float sc=64.+fi*34.;vec2 p=f/sc;',
    '  p.y-=t*(.32+fi*.14);p.x+=sin(p.y*.9+fi*2.3+t*.4)*.3;',
    '  vec2 id=floor(p);vec2 c=fract(p)-.5;float h=hash(id+fi*19.7);',
    '  if(h>.86){vec2 o=vec2(hash(id+3.1)-.5,hash(id+7.7)-.5)*.6;',
    '   float d=length(c-o)*sc;float tw=.55+.45*sin(t*2.6+h*60.);',
    '   s+=smoothstep(1.9+fi*.5,0.,d)*tw*((h-.86)/.14);}}',
    ' return s;}',
    'void main(){',
    ' vec2 f=gl_FragCoord.xy/uDpr;vec2 su=f/uRes;',
    ' float heat=.35+.65*smoothstep(.8,0.,su.y);',
    ' vec2 hz=vec2(fbm(vec2(su.x*7.,su.y*4.-uTime*.8))-.5,fbm(vec2(su.x*5.+3.,su.y*6.-uTime*1.2))-.5);',
    ' vec2 bu=cover(su,uBgA,uRes.x/uRes.y);bu=(bu-.5)/1.12+.5;bu.y+=uRise;bu+=hz*.007*heat;',
    ' vec3 bg=vec3(0.);for(int i=0;i<7;i++){float o=float(i)/6.-.5;bg+=texture2D(uBg,bu+vec2(0.,o*uVel)).rgb;}bg/=7.;',
    ' bg*=1.+.07*sin(uTime*.9+su.x*3.+su.y*2.)*heat;',
    ' float sp=sparks(f,uTime)*uSpark;',
    ' vec3 spc=mix(vec3(1.,.58,.24),vec3(.92,.93,1.),smoothstep(.3,.85,su.y));',
    ' bg+=spc*sp;',
    ' vec2 rel=f-uFlame.xy;vec2 q=rel/uFlame.zw;',
    ' float taper=1.-.52*smoothstep(-.25,1.,q.y);vec2 fq=vec2(q.x/taper,q.y);',
    ' vec2 dir=fq/max(length(fq),1e-4);',
    ' float en=fbm(dir*1.7+vec2(uTime*.3,length(fq)*2.2-uTime*1.));en=.5+(en-.5)*uWob;',
    ' float lick=max(q.y,0.)*(fbm(vec2(q.x*3.2,q.y*2.2-uTime*1.7))-.35)*.8*uWob;',
    ' float d=length(fq)+(en-.5)*.36-lick;',
    ' float e=(d-.78)*uFlame.z;',
    ' float aa=mix(.035,.08,uWob)*uFlame.z;',
    ' float m=1.-smoothstep(-aa,aa,e);',
    ' vec2 hw=vec2(fbm(f*.022+vec2(0.,-uTime*1.6)),fbm(f*.022+vec2(5.2,-uTime*1.6)))-.5;',
    ' vec2 hu=bu+hw*vec2(.05,.11);vec3 haze=vec3(0.);',
    ' for(int i=0;i<6;i++){float a=float(i)*1.047;haze+=texture2D(uBg,hu+vec2(cos(a),sin(a))*.008).rgb;}haze/=6.;',
    ' float core=1.-smoothstep(0.,.8,d);',
    ' float edge=smoothstep(.45,.76,d)*(1.-smoothstep(.76,.9,d));',
    ' haze=haze*1.06+vec3(.3,.13,.03)*core*core*.55+vec3(1.,.62,.28)*edge*.32;',
    ' vec3 paint=mix(haze,uNext,uFill)+vec3(1.,.55,.18)*edge*.55*uFill;',
    ' vec3 col=mix(bg,paint,m);',
    ' gl_FragColor=vec4(col,1.);}'
  ].join('\n');
  var G = null;
  function initGL() {
    if (reduce)
      return null;
    if (navigator.webdriver)
      return null;
    var gl = canvas.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'high-performance' });
    if (!gl)
      return null;
    var dbg = gl.getExtension('WEBGL_debug_renderer_info');
    if (dbg && /swiftshader|llvmpipe|software|basic render/i.test(gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL)))
      return null;
    function sh(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
        console.warn(gl.getShaderInfoLog(s));
        return null;
      }
      return s;
    }
    var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs)
      return null;
    var pr = gl.createProgram();
    gl.attachShader(pr, vs);
    gl.attachShader(pr, fs);
    gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS))
      return null;
    gl.useProgram(pr);
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'a');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
    var U = {};
    ['uBg', 'uVid', 'uWall', 'uRes', 'uDpr', 'uTime', 'uVel', 'uRise', 'uHaze', 'uOpen', 'uWallOn', 'uSpark', 'uBgA', 'uVidA', 'uWallA', 'uFlame', 'uVBox', 'uWob', 'uNext', 'uFill']
      .forEach(function (n) { U[n] = gl.getUniformLocation(pr, n); });
    function tex(unit) {
      var t = gl.createTexture();
      gl.activeTexture(gl.TEXTURE0 + unit);
      gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, 1, 1, 0, gl.RGB, gl.UNSIGNED_BYTE, new Uint8Array([7, 0, 32]));
      return t;
    }
    var T = { bg: tex(0), vid: tex(1), wall: tex(2) };
    gl.uniform1i(U.uBg, 0);
    gl.uniform1i(U.uVid, 1);
    gl.uniform1i(U.uWall, 2);
    var S = { gl: gl, U: U, T: T, bgA: 1.6, vidA: 9 / 16, wallA: 1.6, ready: 0, vidLive: false, lastT: -1, bgSrc: '' };
    function put(t, unit, src) {
      gl.activeTexture(gl.TEXTURE0 + unit);
      gl.bindTexture(gl.TEXTURE_2D, t);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, src);
    }
    S.put = put;
    function load(src, cb) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { cb(im); };
      im.src = src;
    }
    S.loadBg = function () {
      var src = window.RS_GRAD ? (small.matches ? RS_GRAD.tall : RS_GRAD.wide) : small.matches ? RS_FILES + 'gradient-tall.webp' : RS_FILES + 'gradient-wide.webp';
      var el = sky.querySelector('img');
      var cur = el.currentSrc || el.src;
      if (cur && cur.indexOf(src.split('/').pop()) > -1)
        src = cur;
      if (S.bgSrc === src)
        return;
      S.bgSrc = src;
      load(src, function (im) { put(T.bg, 0, im); S.bgA = im.naturalWidth / im.naturalHeight; S.ready |= 1; });
    };
    S.loadBg();
    canvas.addEventListener('webglcontextlost', function (e) { e.preventDefault(); G = null; walk.classList.remove('gl'); });
    return S;
  }
  G = initGL();
  if (G)
    walk.classList.add('gl');
  var t0 = performance.now();
  (function () {
    var fine = matchMedia('(hover: hover) and (pointer: fine)');
    var grab = null, cur = '';
    function can() { return G && fine.matches && scrollY < 4; }
    function home() {
      var s = geo(0);
      return { x: s.fx - DR.x, y: s.fy - DR.y, hx: s.hx, hy: s.hy };
    }
    function over(e) {
      if (!can() || !walk.contains(e.target) || e.target.closest('a, button'))
        return false;
      var h = home(), r = stage.getBoundingClientRect();
      var dx = (e.clientX - r.left - h.x - DR.x) / h.hx, dy = (e.clientY - r.top - h.y - DR.y) / h.hy;
      return dx * dx + dy * dy < 0.8;
    }
    function cursor(c) {
      if (c === cur)
        return;
      cur = c;
      stage.style.cursor = c;
      document.documentElement.style.cursor = c === 'grabbing' ? c : '';
      document.documentElement.style.userSelect = c === 'grabbing' ? 'none' : '';
    }
    function free() {
      if (!grab)
        return;
      try { stage.releasePointerCapture(grab.id); } catch (err) {}
      grab = null;
      DR.held = false;
      cursor('');
    }
    DR.free = free;
    DR.cursor = cursor;
    addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !over(e))
        return;
      e.preventDefault();
      grab = { id: e.pointerId, x: e.clientX - DR.x, y: e.clientY - DR.y };
      DR.held = true;
      DR.tx = DR.x;
      DR.ty = DR.y;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      cursor('grabbing');
    });
    addEventListener('pointermove', function (e) {
      if (!grab) {
        if (e.pointerType === 'mouse')
          cursor(over(e) ? 'grab' : '');
        return;
      }
      var h = home(), W = stage.clientWidth, H = stage.clientHeight, pad = 40;
      DR.tx = Math.max(pad - h.x, Math.min(W - pad - h.x, e.clientX - grab.x));
      DR.ty = Math.max(pad - h.y, Math.min(H - pad - h.y, e.clientY - grab.y));
    });
    ['pointerup', 'pointercancel', 'blur'].forEach(function (n) { addEventListener(n, free); });
    stage.addEventListener('lostpointercapture', free);
  })();
  function dragStep(now) {
    var dt = DR.t ? Math.min(0.05, Math.max(0.001, (now - DR.t) / 1000)) : 0.016;
    DR.t = now;
    if (scrollY >= 4) {
      if (DR.held)
        DR.free();
      else if (DR.cursor)
        DR.cursor('');
    }
    if (DR.held) {
      var px = DR.x, py = DR.y, f = 1 - Math.exp(-dt * 24);
      DR.x += (DR.tx - DR.x) * f;
      DR.y += (DR.ty - DR.y) * f;
      DR.vx = (DR.x - px) / dt;
      DR.vy = (DR.y - py) / dt;
    }
    else if (DR.x || DR.y || DR.vx || DR.vy) {
      DR.vx += (-80 * DR.x - 13 * DR.vx) * dt;
      DR.vy += (-80 * DR.y - 13 * DR.vy) * dt;
      DR.x += DR.vx * dt;
      DR.y += DR.vy * dt;
      if (Math.abs(DR.x) + Math.abs(DR.y) < 0.4 && Math.abs(DR.vx) + Math.abs(DR.vy) < 6)
        DR.x = DR.y = DR.vx = DR.vy = 0;
    }
    DR.heat += (Math.min(0.4, Math.hypot(DR.vx, DR.vy) / 2500) - DR.heat) * 0.15;
  }
  function burnGL(s, p) {
    var gl = G.gl, U = G.U;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var cw = Math.round(s.W * dpr), ch = Math.round(s.H * dpr);
    if (canvas.width !== cw || canvas.height !== ch) {
      canvas.width = cw;
      canvas.height = ch;
      gl.viewport(0, 0, cw, ch);
      G.loadBg();
    }
    gl.uniform2f(U.uRes, s.W, s.H);
    gl.uniform1f(U.uDpr, dpr);
    gl.uniform1f(U.uTime, (performance.now() - t0) / 1000);
    var v = Math.max(-0.05, Math.min(0.05, vel * 1.4));
    gl.uniform1f(U.uVel, v);
    gl.uniform1f(U.uRise, mix(-0.045, 0.045, ease(p)));
    gl.uniform1f(U.uSpark, 1 - 0.7 * s.g);
    gl.uniform1f(U.uBgA, G.bgA);
    gl.uniform1f(U.uVidA, G.vidA);
    gl.uniform1f(U.uWallA, G.wallA);
    gl.uniform4f(U.uFlame, s.fx, s.H - s.fy, s.hx, s.hy);
    gl.uniform1f(U.uWob, Math.min(1, mix(0.6, 1, Math.min(s.g * 4, 1)) + DR.heat));
    gl.uniform3f(U.uNext, NEXT[0] / 255, NEXT[1] / 255, NEXT[2] / 255);
    gl.uniform1f(U.uFill, s.fill);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  }
  function burnCSS(s, p) {
    var w = mix(s.hx * 1.6, s.W * 1.6, s.g), h = mix(s.hy * 1.6, s.H * 1.6, s.g);
    mirage.style.left = (s.fx - w / 2).toFixed(1) + 'px';
    mirage.style.top = (s.fy - h / 2).toFixed(1) + 'px';
    mirage.style.width = w.toFixed(1) + 'px';
    mirage.style.height = h.toFixed(1) + 'px';
    mirage.style.borderRadius = '50% 50% 46% 46% / 64% 64% 36% 36%';
    mirage.style.setProperty('--solid', mix(55, 96, s.g).toFixed(1) + '%');
    mirage.style.background = 'rgb(' + NEXT.join(',') + ')';
    mirage.style.opacity = s.fill.toFixed(3);
    sky.style.transform = 'translate3d(0,' + mix(-20, 20, ease(p)).toFixed(1) + 'px,0)';
  }
  function burn(p) {
    var s = geo(p);
    if (G)
      burnGL(s, p);
    else
      burnCSS(s, p);
    var mb = reduce ? 0 : Math.min(Math.abs(vel) * 90, 3);
    var f = mb > 0.25 ? 'blur(' + mb.toFixed(2) + 'px)' : '';
    title.style.filter = f;
    cta.style.filter = f;
    hint.style.filter = f;
  }
  var chalk = document.querySelector('.chalk');
  var boards = Array.prototype.slice.call(chalk.querySelectorAll('.board img')).slice(1);
  var dust = chalk.querySelector('.board__dust');
  var wipes = [[0.20, 0.36], [0.45, 0.61], [0.70, 0.86]];
  function edge(t, i) {
    var pts = [], n = 14;
    for (var k = 0; k <= n; k++) {
      var yy = k / n;
      var x = t * 124 - 12 + Math.sin(yy * Math.PI * 3.2 + i * 1.7 + t * 5) * 3.2 + (yy - 0.5) * -9;
      pts.push(x.toFixed(2) + '% ' + (yy * 100).toFixed(2) + '%');
    }
    return 'polygon(0% 0%, ' + pts.join(', ') + ', 0% 100%)';
  }
  var CH = null;
  function chalkWipe(p, now) {
    var active = -1, at = 0;
    CH = null;
    for (var i = 0; i < boards.length; i++) {
      var t = range(p, wipes[i][0], wipes[i][1]);
      if (reduce) {
        boards[i].style.clipPath = 'none';
        boards[i].style.opacity = t > 0.5 ? '1' : '0';
        continue;
      }
      if (FL && t > 0 && t < 1) {
        var br = boards[i].parentNode.getBoundingClientRect();
        var R = t * Math.hypot(br.width, br.height) * 1.08;
        arcRadii(R, (now - t0) / 1000, -108);
        boards[i].style.clipPath = arcClip(0, br.height, -108);
        CH = { o: [br.left, br.bottom, R, -108], r: [br.left, br.top, br.width, br.height], fh: Math.min(110, br.height * 0.35) };
      }
      else
        boards[i].style.clipPath = t <= 0 ? 'polygon(0 0, 0 0, 0 100%, 0 100%)' : t >= 1 ? 'none' : edge(t, i);
      if (t > 0 && t < 1) {
        active = i;
        at = t;
      }
    }
    if (FL || reduce || active < 0) {
      dust.style.opacity = '0';
      return;
    }
    var bw = dust.parentNode.getBoundingClientRect().width;
    dust.style.opacity = (Math.sin(at * Math.PI) * 0.9).toFixed(3);
    dust.style.transform = 'translate3d(' + ((at * 1.24 - 0.12) * bw - bw * 0.035).toFixed(1) + 'px,0,0)';
  }
  var services = document.querySelector('.services');
  var cards = Array.prototype.slice.call(services.querySelectorAll('.svc'));
  var rail = services.querySelector('.rail');
  var svStage = services.querySelector('.services__stage');
  var railBtns = services.querySelectorAll('[data-rail]');
  (function () {
    var down = null, moved = false;
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0)
        return;
      down = { x: e.clientX, left: rail.scrollLeft };
      moved = false;
    });
    addEventListener('pointermove', function (e) {
      if (!down)
        return;
      var dx = e.clientX - down.x;
      if (!moved && Math.abs(dx) > 6) {
        moved = true;
        rail.classList.add('is-drag');
      }
      if (moved)
        rail.scrollLeft = down.left - dx;
    });
    addEventListener('pointerup', function () {
      if (!down)
        return;
      down = null;
      if (moved)
        setTimeout(function () { rail.classList.remove('is-drag'); }, 0);
    });
    rail.addEventListener('click', function (e) { if (moved) {
      e.preventDefault();
      e.stopPropagation();
      moved = false;
    } }, true);
    Array.prototype.forEach.call(railBtns, function (b) {
      b.addEventListener('click', function () {
        rail.scrollBy({ left: +b.getAttribute('data-rail') * (cards[0].offsetWidth + 24), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    function ends() {
      railBtns[0].disabled = rail.scrollLeft < 4;
      railBtns[1].disabled = rail.scrollLeft > rail.scrollWidth - rail.clientWidth - 4;
    }
    rail.addEventListener('scroll', ends, { passive: true });
    addEventListener('resize', ends);
    ends();
  })();
  function settle() {
    if (reduce)
      return;
    var vw = innerWidth;
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      cards[i].style.setProperty('--settle', ease(range(vw - r.left, 0, vw * 0.45)).toFixed(3));
    }
  }
  var flareCv = document.querySelector('.flare');
  var award = document.querySelector('.award');
  var awardIcon = award.querySelector('.award__flame');
  var grid = document.querySelector('.grid');
  var FS2 = [
    'precision highp float;',
    'uniform float uDpr,uTime;uniform vec2 uRes;',
    'uniform vec4 uA,uAk,uAm,uB,uBk,uBm;uniform vec3 uNavy;uniform sampler2D uG;',
    'uniform vec4 uT0,uT1,uT2,uT3,uO;uniform float uArc[37],uFH;',
    'float hash(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float noise(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);',
    ' return mix(mix(hash(i),hash(i+vec2(1,0)),u.x),mix(hash(i+vec2(0,1)),hash(i+vec2(1,1)),u.x),u.y);}',
    'float fbm(vec2 p){float s=0.,a=.5;for(int i=0;i<4;i++){s+=a*noise(p);p=p*2.03+7.1;a*=.5;}return s;}',
    'float sparks(vec2 f,float t){float s=0.;',
    ' for(int i=0;i<3;i++){float fi=float(i);float sc=64.+fi*34.;vec2 p=f/sc;',
    '  p.y-=t*(.32+fi*.14);p.x+=sin(p.y*.9+fi*2.3+t*.4)*.3;',
    '  vec2 id=floor(p);vec2 c=fract(p)-.5;float h=hash(id+fi*19.7);',
    '  if(h>.86){vec2 o=vec2(hash(id+3.1)-.5,hash(id+7.7)-.5)*.6;',
    '   float d=length(c-o)*sc;float tw=.55+.45*sin(t*2.6+h*60.);',
    '   s+=smoothstep(1.9+fi*.5,0.,d)*tw*((h-.86)/.14);}}',
    ' return s;}',
    'vec3 grad(vec2 c,vec4 M){vec2 v=(c-M.xy)/M.zw;v=1.-abs(1.-mod(abs(v),2.));return texture2D(uG,vec2(v.x,1.-v.y)).rgb;}',
    'vec4 flame(vec2 f,vec2 c,vec4 F,vec4 K,vec4 M){',
    ' if(K.z<=0.)return vec4(0.);',
    ' vec2 rel=f-F.xy;vec2 q=rel/F.zw;',
    ' float taper=1.-.52*smoothstep(-.25,1.,q.y);vec2 fq=vec2(q.x/taper,q.y);',
    ' vec2 dir=fq/max(length(fq),1e-4);',
    ' float en=fbm(dir*1.7+vec2(uTime*.3,length(fq)*2.2-uTime*1.));en=.5+(en-.5)*K.x;',
    ' float lick=max(q.y,0.)*(fbm(vec2(q.x*3.2,q.y*2.2-uTime*1.7))-.35)*.8*K.x;',
    ' float d=length(fq)+(en-.5)*.36-lick;',
    ' float e=(d-.78)*F.z;',
    ' float aa=max(mix(.035,.08,K.x)*F.z,.7);',
    ' float m=1.-smoothstep(-aa,aa,e);',
    ' if(m<=0.)return vec4(0.);',
    ' float sc=clamp(F.w/150.,.12,1.);',
    ' vec2 hw=vec2(fbm(f*.022/sc+vec2(0.,-uTime*1.6)),fbm(f*.022/sc+vec2(5.2,-uTime*1.6)))-.5;',
    ' vec2 hc=c+hw*vec2(72.,100.)*sc;vec3 haze=vec3(0.);',
    ' for(int i=0;i<6;i++){float a=float(i)*1.047;haze+=grad(hc+vec2(cos(a),sin(a))*max(10.*sc,1.5),M);}haze/=6.;',
    ' float core=1.-smoothstep(0.,.8,d);',
    ' float edge=smoothstep(.45,.76,d)*(1.-smoothstep(.76,.9,d));',
    ' haze=haze*1.06+vec3(.3,.13,.03)*core*core*.55+vec3(1.,.62,.28)*edge*.32;',
    ' vec3 night=uNavy+vec3(1.,.55,.18)*edge*.55;',
    ' vec3 col=mix(night,haze,K.y)*(1.+K.w*.3);',
    ' return vec4(col*m,m)*K.z;}',
    'vec4 fire(vec2 f,vec4 F,vec4 K){',
    ' if(K.z<=0.)return vec4(0.);',
    ' vec2 q=(f-F.xy)/F.zw;float up=smoothstep(-.4,1.1,q.y);',
    ' q.x+=(fbm(vec2(q.y*1.3-uTime*2.2,uTime*.7))-.5)*.9*up*up;',
    ' vec2 fq=vec2(q.x/(1.-.66*up),q.y*.78);',
    ' float n=fbm(vec2(q.x*2.6,q.y*1.5-uTime*3.));',
    ' float n2=fbm(vec2(q.x*6.,q.y*3.6-uTime*4.6)+3.1);',
    ' float d=length(fq)+(n-.5)*(.25+1.1*up)+(n2-.5)*.5*up;',
    ' float I=clamp(1.-d/.85,0.,1.);',
    ' if(I<=0.)return vec4(0.);',
    ' float hot=I*I*(1.-.6*up);',
    ' vec3 col=texture2D(uG,vec2(.5,mix(.6,.04,hot))).rgb*(.9+hot*.7)+vec3(.45,.4,.3)*pow(hot,3.);',
    ' float a=smoothstep(0.,.3,I)*(.55+.45*hot)*(1.-.25*up);',
    ' return vec4(col*a,a)*K.z;}',
    'float tile(vec2 c,vec4 r){vec2 q=abs(c-r.xy-r.zw*.5)-r.zw*.5+18.;',
    ' float dd=length(max(q,0.))+min(max(q.x,q.y),0.)-18.;return 1.-smoothstep(-.5,.5,dd);}',
    'vec4 burn(vec2 f,vec2 c){',
    ' if(uO.z<=0.)return vec4(0.);',
    ' float tm=max(max(tile(c,uT0),tile(c,uT1)),max(tile(c,uT2),tile(c,uT3)));',
    ' if(tm<=0.)return vec4(0.);',
    ' vec2 rel=c-uO.xy;float dist=length(rel);',
    ' float ang=mod(degrees(atan(rel.y,rel.x))-uO.w+720.,360.);float fi=clamp(ang/(120./36.),0.,35.999);',
    ' float r=uO.z;for(int i=0;i<36;i++){if(float(i)==floor(fi))r=mix(uArc[i],uArc[i+1],fract(fi));}',
    ' float s=dist-r;',
    ' float gy=rel.y/max(dist,1.);float sg=gy>=0.?1.:-1.;',
    ' float h=-s/(sg*max(abs(gy),.3));float hh=h>=0.?h:-h*5.;',
    ' float n=fbm(vec2(c.x*.042,c.y*.016+uTime*2.3))*.72+fbm(vec2(c.x*.11+5.,c.y*.045+uTime*3.6))*.42;',
    ' float v=n*1.25-hh/uFH;',
    ' float F=smoothstep(.2,1.,v);float hot=F*F;',
    ' vec3 fire=texture2D(uG,vec2(.5,mix(.6,.04,hot))).rgb*(.9+hot*.7)+vec3(.45,.4,.3)*pow(hot,3.);',
    ' float a=smoothstep(0.,.35,F)*(.35+.6*hot);',
    ' float em=exp(-abs(s)/2.5)*(.5+.8*fbm(vec2(c.x*.08,c.y*.08-uTime*1.2)));',
    ' vec3 col=fire*a;float A=a;',
    ' vec3 ec=texture2D(uG,vec2(.5,.12)).rgb*1.3;col+=ec*em*(1.-A);A+=em*.9*(1.-A);',
    ' float ch=.5*(1.-smoothstep(0.,60.,s))*step(-1.,s);',
    ' float sp=sparks(f,uTime)*exp(-max(hh-10.,0.)/40.)*1.3;',
    ' col+=vec3(1.,.72,.38)*sp;A=min(1.,A+sp);',
    ' col+=vec3(.06,.015,0.)*ch*(1.-A);A+=ch*(1.-A);',
    ' return vec4(col,A)*tm;}',
    'void main(){vec2 f=gl_FragCoord.xy/uDpr;vec2 c=vec2(f.x,uRes.y-f.y);',
    ' vec4 A=flame(f,c,uA,uAk,uAm);vec4 B=fire(f,uB,uBk);',
    ' vec4 o=B+A*(1.-B.a);o+=burn(f,c)*(1.-o.a);',
    ' gl_FragColor=o;}'
  ].join('\n');
  function initFlare() {
    if (reduce || !G)
      return null;
    var gl = flareCv.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, preserveDrawingBuffer: true });
    if (!gl)
      return null;
    function sh(t, src) { var o = gl.createShader(t); gl.shaderSource(o, src); gl.compileShader(o); return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null; }
    var vs = sh(gl.VERTEX_SHADER, VS), fs = sh(gl.FRAGMENT_SHADER, FS2);
    if (!vs || !fs)
      return null;
    var pr = gl.createProgram();
    gl.attachShader(pr, vs);
    gl.attachShader(pr, fs);
    gl.linkProgram(pr);
    if (!gl.getProgramParameter(pr, gl.LINK_STATUS))
      return null;
    gl.useProgram(pr);
    var b = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, b);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(pr, 'a');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var U = {};
    ['uDpr', 'uTime', 'uRes', 'uA', 'uAk', 'uAm', 'uB', 'uBk', 'uBm', 'uNavy', 'uG', 'uT0', 'uT1', 'uT2', 'uT3', 'uO', 'uArc', 'uFH'].forEach(function (n) { U[n] = gl.getUniformLocation(pr, n); });
    gl.uniform3f(U.uNavy, NEXT[0] / 255, NEXT[1] / 255, NEXT[2] / 255);
    var tx = gl.createTexture();
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, tx);
    [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach(function (w) { gl.texParameteri(gl.TEXTURE_2D, w, gl.CLAMP_TO_EDGE); });
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, 1, 1, 0, gl.RGB, gl.UNSIGNED_BYTE, new Uint8Array([180, 60, 20]));
    gl.uniform1i(U.uG, 0);
    var im = new Image();
    im.onload = function () { gl.bindTexture(gl.TEXTURE_2D, tx); gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true); gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGB, gl.RGB, gl.UNSIGNED_BYTE, im); };
    im.src = RS_FILES + 'gradient-wide.webp';
    gl.clearColor(0, 0, 0, 0);
    return { gl: gl, U: U, drawn: true };
  }
  var FL = initFlare();
  if (FL)
    document.documentElement.classList.add('fl-on');
  function hostFire(host, cls) {
    if (!FL)
      return null;
    var cv = document.createElement('canvas');
    cv.className = cls;
    cv.setAttribute('aria-hidden', 'true');
    host.appendChild(cv);
    cv._x = cv.getContext('2d');
    return cv;
  }
  var awardFire = hostFire(award, 'award__fire'), gridFire = hostFire(grid, 'grid__fire'), FLY = 0, keepOK;
  var tiles = !FL ? [] : Array.prototype.map.call(grid.querySelectorAll('.tile'), function (fig) {
    var col = fig.querySelector('img');
    var sk = document.createElement('img');
    sk.className = 'tile__sketch';
    sk.alt = '';
    sk.setAttribute('aria-hidden', 'true');
    sk.decoding = 'async';
    sk.src = col.getAttribute('src').replace('.webp', '-sketch.webp');
    if (col.getAttribute('style'))
      sk.setAttribute('style', col.getAttribute('style'));
    fig.insertBefore(sk, col);
    return { fig: fig, col: col, state: -1 };
  });
  function hash1(i) { var x = Math.sin(i * 127.1) * 43758.5453; return x - Math.floor(x); }
  function vnoise(x) { var i = Math.floor(x), f = x - i; f = f * f * (3 - 2 * f); return mix(hash1(i), hash1(i + 1), f); }
  var ARC = new Float32Array(37);
  function arcRadii(R, t, a0) {
    var amp = Math.min(R * 0.12, 34);
    for (var i = 0; i < 37; i++) {
      var a = (a0 + i * 120 / 36) * Math.PI / 180;
      var n = vnoise(a * 7 + t * 0.9) * 0.65 + vnoise(a * 19 - t * 1.7) * 0.35;
      ARC[i] = Math.max(0, R + (n - 0.5) * 2 * amp);
    }
  }
  function arcClip(x, y, a0) {
    var pts = [x.toFixed(1) + 'px ' + y.toFixed(1) + 'px'];
    for (var i = 0; i < 37; i++) {
      var a = (a0 + i * 120 / 36) * Math.PI / 180;
      pts.push((x + Math.cos(a) * ARC[i]).toFixed(1) + 'px ' + (y + Math.sin(a) * ARC[i]).toFixed(1) + 'px');
    }
    return 'polygon(' + pts.join(',') + ')';
  }
  var NONE = 'inset(0 100% 100% 0)';
  function burnTiles(ox, oy, Rb) {
    var live = false;
    for (var i = 0; i < tiles.length; i++) {
      var T = tiles[i], r = T.fig.getBoundingClientRect();
      var lx = ox - r.left, ly = oy - r.top;
      var reach = Math.hypot(Math.max(Math.abs(lx), Math.abs(lx - r.width)), Math.max(Math.abs(ly), Math.abs(ly - r.height)));
      var state = Rb <= 0 ? 0 : Rb - 60 >= reach ? 2 : 1;
      if (state === 1 || (Rb > 0 && Rb - reach < 260))
        live = true;
      if (state !== 1 && state === T.state)
        continue;
      T.state = state;
      T.col.style.clipPath = state === 0 ? NONE : state === 2 ? 'none' : arcClip(lx, ly, -12);
    }
    return live;
  }
  function placed(l, t, w, h) {
    var s = Math.max(w / 1440, h / 900), iw = 1440 * s, ih = 900 * s;
    return [l + (w - iw) * 0.5, t + (h - ih) * 0.7, iw, ih];
  }
  function inBox(r, sc) {
    var hy = r.height / 1.56 * sc;
    return { x: r.left + r.width / 2, y: r.top + r.height / 2, hx: hy * 0.58, hy: hy };
  }
  function unveil(heroEnd) {
    var H = innerHeight;
    if (pinProof)
      return (proof.offsetHeight - H) * 0.85;
    var at = award.getBoundingClientRect().top + scrollY;
    return Math.min(H * 0.7, Math.max(H * 0.25, at - heroEnd - H * 0.42));
  }
  function keep(F, cr, cv, isB, dpr, t, W, H) {
    var gl = FL.gl, U = FL.U;
    var px = F.hx * 1.5 + 24, up = F.hy * 1.5 + 24, bw = Math.min(W, px * 2), bh = Math.min(H, up + F.hy * 1.1 + 24);
    var dx = px - F.x, dy = up - F.y, cw = Math.ceil(bw * dpr), ch = Math.ceil(bh * dpr);
    gl.enable(gl.SCISSOR_TEST);
    gl.scissor(0, flareCv.height - ch, cw, ch);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform1f(U.uDpr, dpr);
    gl.uniform1f(U.uTime, t);
    gl.uniform2f(U.uRes, W, H);
    var u4 = isB ? U.uB : U.uA, k4 = isB ? U.uBk : U.uAk;
    gl.uniform4f(isB ? U.uAk : U.uBk, 0, 0, 0, 0);
    gl.uniform4f(u4, F.x + dx, H - (F.y + dy), F.hx, F.hy);
    gl.uniform4f(k4, F.wob, F.haze, F.a, F.flare);
    gl.uniform4f(U.uAm, F.m[0] + dx, F.m[1] + dy, F.m[2], F.m[3]);
    gl.uniform4f(U.uO, 0, 0, 0, 0);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    if (cv.width !== cw || cv.height !== ch) {
      cv.width = cw;
      cv.height = ch;
    }
    else
      cv._x.clearRect(0, 0, cw, ch);
    cv._x.drawImage(flareCv, 0, 0, cw, ch, 0, 0, cw, ch);
    if (keepOK === undefined)
      keepOK = cv._x.getImageData(Math.round(px * dpr), Math.round(up * dpr), 1, 1).data[3] > 0;
    if (!keepOK) {
      drop(cv);
      return false;
    }
    gl.clear(gl.COLOR_BUFFER_BIT);
    cv.style.cssText = 'display:block;left:' + (F.x - px - cr.left).toFixed(1) + 'px;top:' + (F.y - up - cr.top).toFixed(1) + 'px;width:' + bw.toFixed(1) + 'px;height:' + bh.toFixed(1) + 'px';
    cv._on = true;
    return true;
  }
  function drop(cv) {
    if (cv._on) {
      cv.style.display = 'none';
      cv._on = false;
    }
  }
  function flare(now) {
    if (!FL) {
      var wr0 = walk.getBoundingClientRect();
      stage.style.visibility = wr0.bottom <= stage.offsetHeight + 0.5 ? 'hidden' : '';
      return;
    }
    var gl = FL.gl, U = FL.U;
    var W = innerWidth, H = innerHeight, y = scrollY, t = (now - t0) / 1000;
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var cw = Math.round(W * dpr), ch = Math.round(H * dpr);
    if (flareCv.width !== cw || flareCv.height !== ch) {
      flareCv.width = cw;
      flareCv.height = ch;
      gl.viewport(0, 0, cw, ch);
    }
    var wr = walk.getBoundingClientRect();
    var heroEnd = wr.top + y + wr.height - stage.offsetHeight;
    var unv = unveil(heroEnd);
    var on = y >= heroEnd - 0.5;
    stage.style.visibility = on ? 'hidden' : '';
    var A = null, B = null;
    var cr = award.getBoundingClientRect();
    var T = inBox(awardIcon.getBoundingClientRect(), 1);
    if (on) {
      var u = range(y, heroEnd, heroEnd + unv), s1 = geo(1);
      var hy = Math.exp(mix(Math.log(s1.hy), Math.log(T.hy), ease(u)));
      var k = clamp01((s1.hy - hy) / (s1.hy - T.hy));
      A = { x: mix(s1.fx, T.x, k), y: mix(s1.fy, T.y, k), hx: hy * mix(s1.hx / s1.hy, 0.58, k), hy: hy,
        wob: mix(1, 0.6, k), haze: ease(range(u, 0.5, 0.92)), a: 1, flare: 0,
        m: placed(cr.left, cr.top, cr.width, cr.height) };
      if (u >= 1 && (cr.bottom < -40 || cr.top > H + 40))
        A = null;
    }
    var gr = grid.getBoundingClientRect();
    var ox = gr.left + 8, oy = gr.top + 8;
    var mult = small.matches ? 1.2 : 2;
    if (tiles.length) {
      var lr0 = tiles[tiles.length - 1].fig.getBoundingClientRect();
      var dC0 = Math.hypot(lr0.right - 16 - ox, lr0.bottom - 16 - oy) + 30;
      var room = services.getBoundingClientRect().top - H * 1.05 - (gr.top - H * 0.62);
      if (room > 40)
        mult = Math.max(mult, dC0 / room);
    }
    var Rb = Math.max(0, H * 0.62 - gr.top) * mult;
    var land = gr.top + y - H * 0.62;
    var s0 = Math.max(heroEnd + unv + H * 0.05, land - H * 0.45);
    if (!on || y < s0)
      FLY = 0;
    else if (!FLY)
      FLY = now;
    var ts = FLY ? clamp01((now - FLY) / 900) : 0;
    if (FLY && Rb < 70) {
      var e = ease(ts), sx = T.x, sy = T.y;
      var lift = Math.min(120, Math.hypot(ox - sx, oy - sy) * 0.25);
      var bs = 0.72 * (1 + 0.8 * range(Rb, 0, 70));
      var bx = mix(sx, ox, e), by = mix(sy, oy, e) - Math.sin(e * Math.PI) * lift;
      var bhx = T.hx * bs, bhy = T.hy * bs;
      B = { x: bx, y: by, hx: bhx, hy: bhy, wob: 0.85, haze: 1, a: 1 - range(Rb, 20, 70), flare: 0.2,
        m: placed(bx - bhx * 1.4, by - bhy * 1.3, bhx * 2.8, bhy * 2.6), rest: ts >= 1 };
      if (A) {
        var fl = Math.sin(range(ts, 0, 0.3) * Math.PI);
        A.flare = fl;
        A.hx *= 1 + 0.15 * fl;
        A.hy *= 1 + 0.15 * fl;
      }
    }
    var burning = false;
    if (tiles.length && gr.bottom > -H && gr.top < H * 2) {
      arcRadii(Rb, t, -12);
      burning = burnTiles(ox, oy, Rb) && gr.bottom > 0 && gr.top < H;
    }
    var svBurn = null;
    var sv = svStage.getBoundingClientRect();
    if (tiles.length && sv.top < H * 1.6 && sv.bottom > 0) {
      var lr = tiles[tiles.length - 1].fig.getBoundingClientRect();
      var cx = lr.right - 16, cy = lr.bottom - 16;
      var dCorner = Math.hypot(cx - ox, cy - oy);
      var yBorn = gr.top + y - H * 0.62 + (dCorner + 30) / mult;
      var born = range(Rb, dCorner - 110, dCorner + 30);
      var yIg = Math.max(sv.top + y - H * 0.85, yBorn + H * 0.22);
      var yEnd = Math.max(sv.top + y - H * 0.45, yIg + H * 0.25);
      var full = Math.hypot(W, H) * 1.12;
      var Rs = range(y, yIg, yEnd) * full;
      var sState = y < yIg ? 0 : Rs >= full ? 2 : 1;
      if (sState === 1) {
        arcRadii(Rs, t, 168);
        svStage.style.clipPath = arcClip(W - sv.left, H - sv.top, 168);
        var top = Math.max(sv.top - 60, -40);
        svBurn = { o: [W, H, Rs, 168], r: [-40, top, W + 80, Math.min(sv.bottom, H + 40) - top], fh: Math.min(200, H * 0.24) };
      }
      else if (sState !== svStage._st)
        svStage.style.clipPath = sState === 0 ? NONE : 'none';
      svStage._st = sState;
      if (born > 0 && Rs < 160) {
        var ej = ease(range(y, yBorn + H * 0.04, yIg));
        var jx = mix(cx, W - 34, ej), jy = mix(cy, H - 30, ej) - Math.sin(ej * Math.PI) * 60;
        var jh = Math.min(84, H * 0.1) * (0.35 + 0.65 * born) * (1 + 0.5 * range(Rs, 0, 60));
        B = { x: jx, y: jy, hx: jh * 0.58, hy: jh, wob: 0.85, haze: 1, a: born * (1 - range(Rs, 60, 160)), flare: 0, m: [0, 0, 1, 1] };
      }
    }
    else if (svStage._st !== 2 && sv.bottom <= 0) {
      svStage.style.clipPath = 'none';
      svStage._st = 2;
    }
    if (A && u >= 0.995 && keepOK !== false && keep(A, cr, awardFire, false, dpr, t, W, H))
      A = null;
    else
      drop(awardFire);
    if (B && B.rest && B.a > 0 && keepOK !== false && keep(B, gr, gridFire, true, dpr, t, W, H))
      B = null;
    else
      drop(gridFire);
    var act = svBurn || CH || (burning ? 'tiles' : null);
    if (!A && !B && !act) {
      if (FL.drawn) {
        gl.disable(gl.SCISSOR_TEST);
        gl.clear(gl.COLOR_BUFFER_BIT);
        FL.drawn = false;
      }
      return;
    }
    gl.disable(gl.SCISSOR_TEST);
    gl.clear(gl.COLOR_BUFFER_BIT);
    var x0 = W, x1 = 0, y0 = H, y1 = 0;
    [A, B].forEach(function (F) {
      if (!F)
        return;
      x0 = Math.min(x0, F.x - F.hx * 1.2 - 20);
      x1 = Math.max(x1, F.x + F.hx * 1.2 + 20);
      y0 = Math.min(y0, F.y - F.hy * 1.3 - 20);
      y1 = Math.max(y1, F.y + F.hy * 1.0 + 20);
    });
    if (burning) {
      x0 = Math.min(x0, gr.left);
      x1 = Math.max(x1, gr.right);
      y0 = Math.min(y0, gr.top);
      y1 = Math.max(y1, gr.bottom);
    }
    if (svBurn) {
      x0 = 0;
      y0 = 0;
      x1 = W;
      y1 = H;
    }
    if (CH) {
      x0 = Math.min(x0, CH.r[0] - 4);
      x1 = Math.max(x1, CH.r[0] + CH.r[2] + 4);
      y0 = Math.min(y0, CH.r[1] - 4);
      y1 = Math.max(y1, CH.r[1] + CH.r[3] + 4);
    }
    x0 = Math.max(0, x0);
    y0 = Math.max(0, y0);
    x1 = Math.min(W, x1);
    y1 = Math.min(H, y1);
    if (x1 <= x0 || y1 <= y0) {
      FL.drawn = false;
      return;
    }
    gl.enable(gl.SCISSOR_TEST);
    gl.scissor(Math.floor(x0 * dpr), Math.floor((H - y1) * dpr), Math.ceil((x1 - x0) * dpr), Math.ceil((y1 - y0) * dpr));
    gl.uniform1f(U.uDpr, dpr);
    gl.uniform1f(U.uTime, t);
    gl.uniform2f(U.uRes, W, H);
    function put(F, u4, k4, m4) {
      if (!F) {
        gl.uniform4f(k4, 0, 0, 0, 0);
        gl.uniform4f(u4, 0, 0, 1, 1);
        gl.uniform4f(m4, 0, 0, 1, 1);
        return;
      }
      gl.uniform4f(u4, F.x, H - F.y, F.hx, F.hy);
      gl.uniform4f(k4, F.wob, F.haze, F.a, F.flare);
      gl.uniform4f(m4, F.m[0], F.m[1], F.m[2], F.m[3]);
    }
    put(A, U.uA, U.uAk, U.uAm);
    put(B, U.uB, U.uBk, U.uBm);
    var tr = [U.uT0, U.uT1, U.uT2, U.uT3];
    if (act && act !== 'tiles') {
      for (var i = 0; i < 4; i++) {
        if (i === 0)
          gl.uniform4f(tr[0], act.r[0], act.r[1], act.r[2], act.r[3]);
        else
          gl.uniform4f(tr[i], -9e3, -9e3, 1, 1);
      }
      gl.uniform4f(U.uO, act.o[0], act.o[1], Math.max(act.o[2], 0.001), act.o[3]);
      gl.uniform1f(U.uFH, act.fh);
    }
    else {
      for (var i = 0; i < 4; i++) {
        var r = tiles[i] ? tiles[i].fig.getBoundingClientRect() : null;
        if (r)
          gl.uniform4f(tr[i], r.left, r.top, r.width, r.height);
        else
          gl.uniform4f(tr[i], -9e3, -9e3, 1, 1);
      }
      gl.uniform4f(U.uO, ox, oy, burning ? Math.max(Rb, 0.001) : 0, -12);
      gl.uniform1f(U.uFH, small.matches ? 80 : 130);
    }
    gl.uniform1fv(U.uArc, ARC);
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    FL.drawn = true;
  }
  (function () {
    if (reduce)
      return;
    var idle = 0, dir = 1, last = scrollY, anim = 0, touching = false;
    function zone() {
      var wr = walk.getBoundingClientRect(), y = scrollY;
      var top = wr.top + y, travel = Math.max(wr.height - innerHeight, 1);
      var heroEnd = top + wr.height - stage.offsetHeight;
      var unv = unveil(heroEnd);
      return { a: top + travel * 0.35, top: top, land: Math.round(heroEnd + unv) };
    }
    function stop() { if (anim) {
      cancelAnimationFrame(anim);
      anim = 0;
      document.documentElement.style.scrollBehavior = '';
    } }
    function glide(to) {
      var from = scrollY, d = to - from;
      if (Math.abs(d) < 2)
        return;
      var dur = Math.min(1100, Math.max(450, Math.abs(d) / innerHeight * 520)), t0g = performance.now();
      document.documentElement.style.scrollBehavior = 'auto';
      (function step(now) {
        var k = Math.min(1, (now - t0g) / dur), e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
        scrollTo(0, from + d * e);
        if (k < 1)
          anim = requestAnimationFrame(step);
        else {
          anim = 0;
          document.documentElement.style.scrollBehavior = '';
          last = scrollY;
        }
      })(t0g);
    }
    function rest() {
      idle = 0;
      if (anim || touching)
        return;
      var z = zone(), y = scrollY;
      if (y <= z.a || y >= z.land - 2)
        return;
      glide(dir > 0 ? z.land : z.top);
    }
    addEventListener('scroll', function () {
      if (anim)
        return;
      var y = scrollY;
      if (y !== last)
        dir = y > last ? 1 : -1;
      last = y;
      clearTimeout(idle);
      idle = setTimeout(rest, 160);
    }, { passive: true });
    ['wheel', 'keydown', 'pointerdown'].forEach(function (n) { addEventListener(n, stop, { passive: true }); });
    addEventListener('touchstart', function () { touching = true; stop(); }, { passive: true });
    addEventListener('touchend', function () { touching = false; clearTimeout(idle); idle = setTimeout(rest, 220); }, { passive: true });
  })();
  function frame(now) {
    var y = scrollY;
    vel += (((y - lastY) / Math.max(innerHeight, 1)) - vel) * 0.25;
    lastY = y;
    dragStep(now || performance.now());
    if (near(walk))
      burn(actP(walk));
    CH = null;
    if (near(chalk))
      chalkWipe(actP(chalk), now || performance.now());
    flare(now || performance.now());
    if (near(services))
      settle();
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
  var topic = document.getElementById('topic');
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-topic]');
    if (!b)
      return;
    if (!topic)
      return;
    topic.value = b.getAttribute('data-topic');
    if (b.tagName === 'BUTTON') {
      document.getElementById('contact').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    }
    setTimeout(function () { topic.focus({ preventScroll: true }); }, reduce ? 0 : 900);
  });
  var form = document.getElementById('enquiry');
  if (form)
    form.addEventListener('submit', function (e) {
      var name = document.getElementById('your-name'), email = document.getElementById('email');
      var note = document.getElementById('form-note');
      if (!name || !email)
        return;
      if (!name.value.trim() || !email.value.trim() || email.value.indexOf('@') < 1) {
        e.preventDefault();
        note.textContent = 'Please add your name and a real email.';
        (name.value.trim() ? email : name).focus();
      }
    });
})();
